import styled from 'styled-components'
import Box, {BoxProps} from './Box'

const Centered = styled(Box).attrs<BoxProps>(props => ({
  $styles: {
    textAlign: 'center',
    ...(props.$styles || {}),
  },
}))({})

export default Centered
